import React,{useState, useEffect} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

//form 
import {TextField} from '@material-ui/core';
import axios from 'axios';
import {useForm} from 'react-hook-form';

//notification
import {NotificationContainer,NotificationManager} from 'react-notifications';
import IntlMessages from 'util/IntlMessages';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function Refund(props) {

 const [open,setOpen] = useState(false);
    useEffect(() => {
        if(props.refundOpen) {
          getRefund();
          setOpen(true);
        }

    
    },[props.refundOpen]) 
    
  const handleClose = () => {
    setOpen(false); 
   
  }

  useEffect(() => {
  
    if(!open){
      props.changeRefund();
    }

   },[!open]) 
  

  const [refunded, setRefunded] = useState({});
  const getRefund = () => {
    if(props.refundData.refund ===1){
      axios.get('api/refund/'+props.refundData.id+'/edit')
      .then(res => {
        setRefunded(res.data);
        setDatetime(res.data.datetime);
        setScc(res.data.scc);
        setCb(res.data.cb);
      }
      ).catch( err =>{
      
      })
    }
  }

  
  const {register, handleSubmit}=useForm();

  const [cb , setCb] = useState();
  const [scc , setScc] = useState();
  const [datetime , setDatetime] = useState();
  const onSubmit = (data) => {
    data['user_id'] = JSON.parse(localStorage.getItem('UserData')).id;
    data['sales_id'] = props.refundData.id;
    data['cb'] = cb;
    data['scc'] = scc;
    data['datetime'] = datetime;

    if(refunded !== null){
      axios.put('api/refund/'+refunded.id, data)
      .then( res => {
          NotificationManager.success(<IntlMessages id="notification.successMessage"/>, <IntlMessages
          id="notification.titleHere" />);
          setOpen(false)
        }
    ).catch( err =>{
          NotificationManager.error(<IntlMessages id="notification.errorMessage"/>, <IntlMessages
          id="notification.titleHere"/>);
        }
     )
    }else{
      axios.post('api/refund', data)
      .then( res => {
            NotificationManager.success(<IntlMessages id="notification.successMessage"/>, <IntlMessages
            id="notification.titleHere" />);
            setOpen(false)
          }
      ).catch( err =>{
            NotificationManager.error(<IntlMessages id="notification.errorMessage"/>, <IntlMessages
            id="notification.titleHere"/>);
          }
      )
    }
  };


  return (
    <>
    <div>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} maxWidth="md" fullWidth="md">
      <form  onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Refund Sell {props.refundData.serial_no}
        </DialogTitle>
        <DialogContent dividers>
          <div className="row">
            <div className="col-md-4">

            <TextField name="datetime" fullWidth={true} type="datetime-local"  className="form-control m-3"   size="small"  margin="normal"  label="Date" variant="outlined"
             value={datetime} 
             onChange={(e) => setDatetime(e.target.value)}
             InputLabelProps={{
              shrink: true,
              }}
              />

            <TextField name="cb" type="number" className="form-control m-3"  size="small" label="C.B" variant="outlined" placeholder="C.B" 
             value={cb} 
             onChange={(e) => setCb(e.target.value)}
             InputLabelProps={{
              shrink: true,
              }}
              /> 
            <TextField name="scc" type="number" className="form-control m-3"   size="small" label="S.C.C" variant="outlined"
             placeholder="S.C.C"
             value={scc} 
             onChange={(e) => setScc(e.target.value)}
             InputLabelProps={{
              shrink: true,
              }}
              /> 
            <TextField name="remark" className="form-control m-3" size="small" defaultValue={refunded?.remark} label="Remark" variant="outlined" multiline={true}
              placeholder="Remark"
              inputRef={register}
              InputLabelProps={{
                shrink: true,
              }}
              /> 

            {refunded !==null? (
                  <div className="chat-date col-xl-2 col-3 ml-2 mt-4">
                  <div className="bg-primary badge text-white">Refunded by: {refunded?.user?.name}</div>
                 </div>
            ):''}
           
            </div>
            <div className="col-md-1 p-0 d-flex justify-content-center">
            <div className="vl"></div>
            </div>
            <div className="col-md-7 pr-0 pl-0">
              <div className="row mb-3">
                <div className="col-md-4">
                  <strong>Customer: </strong>
                  {props.refundData.customer?.name}
                </div>
                <div className="col-md-4">
                <strong>Supplier: </strong>
                  {props.refundData.supplier?.name}
                </div>
                <div className="col-md-4">
                <strong>Currency: </strong>
                  {props.refundData?.currency}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4">
                  <strong>Adults: </strong>
                  {props.refundData?.adults}
                </div>
                <div className="col-md-4">
                <strong>Kids: </strong>
                  {props.refundData?.kids}
                </div>
                <div className="col-md-4">
                <strong>Infants: </strong>
                  {props.refundData?.infants}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4">
                  <strong>Adult Purchase: </strong>
                  {props.refundData?.adlPurchase}
                </div>
                <div className="col-md-4">
                <strong>Kid purchase: </strong>
                  {props.refundData?.kidPurchase}
                </div>
                <div className="col-md-4">
                <strong>Infant Purchase: </strong>
                  {props.refundData?.infPurchase}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4">
                  <strong>Adults Sell: </strong>
                  {props.refundData?.adlSell}
                </div>
                <div className="col-md-4">
                <strong>Kids Sell: </strong>
                  {props.refundData?.kidSell}
                </div>
                <div className="col-md-4">
                <strong>Infants Sell: </strong>
                  {props.refundData?.infSell}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4">
                  <strong>Discount: </strong>
                  {props.refundData?.adlSell}
                </div>
                <div className="col-md-4">
                <strong>Extra: </strong>
                  {props.refundData?.kidSell}
                </div>
                <div className="col-md-4">
                <strong>Commission: </strong>
                  {props.refundData?.infSell}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4">
                  <strong>Paid: </strong>
                  {props.refundData?.adlSell}
                </div>
                <div className="col-md-4">
                <strong>Total: </strong>
                  {props.refundData?.kidSell}
                </div>
              </div>

            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus type="submit" color="primary" variant="contained">
            Save changes
          </Button>
        </DialogActions>
        </form>
      </Dialog>
    </div>
    <NotificationContainer/>
    </>
  );
}
